import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import { Pagination } from '@mui/lab';
import {
    Box, Container, Grid,
    Typography, CircularProgress
} from '@mui/material';

import Page from 'components/Page';
import useArray from 'hooks/useArray';
import { Toolbar, ForumCard } from './components';
import useSnackbar from 'hooks/useSnackbar';
import RequestUtils from 'modules/api/RequestUtils';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
}));

function ForunsList() {
    const classes = useStyles();
    const snackbar = useSnackbar();
    const [awaitData, setAwaitingData] = useState(false);
    const arrForuns = useArray([]);
    const [inputValue, setInputValue] = useState('');
    const [pagedObject, setPagedObject] = useState({
        searchTerm: '',
        page: 1,
        itensPerPage: 12,
        forumIsActive: true,
        amountPage: 1
    });

    function componentMount() {
        handlePagedForuns(pagedObject);
    }
    useEffect(componentMount, []);

    async function handlePagedForuns(pagedObject) {
        setAwaitingData(true);
        RequestUtils.getForumPaged(
            pagedObject.searchTerm,
            pagedObject.page,
            pagedObject.itensPerPage,
            pagedObject.forumIsActive
        ).then((res) => {
            if (res?.svStatus && res.data) {
                const data = res.data;
                setPagedObject({ ...pagedObject, amountPage: data.pageCount });
                arrForuns.setValue(data.listForums);
            } else {
                snackbar(res.msg || "Não foi possível listar fóruns.").error();
            }
            setAwaitingData(false);
        }).catch((e) => {
            snackbar("Erro ao listar fóruns.").error();
            setAwaitingData(false);
        });
    }

    function onPressButton() {
        const obj = { ...pagedObject, page: 1, searchTerm: inputValue };
        setPagedObject(obj);
        handlePagedForuns(obj);
    }

    function handleChange(label, value) {
        let obj = pagedObject;

        switch (label) {
            case "searchTerm":
                setInputValue(value);
                if (value === "") obj = { ...obj, page: 1, searchTerm: value };
                break;
            case "forumIsActive":
                obj = { ...obj, page: 1, forumIsActive: value };
                break;
            default:
                break;
        }

        setPagedObject(obj);
        if (label !== "searchTerm" || value === "") handlePagedForuns(obj);
    }

    function handleChangePage(event, value) {
        const obj = { ...pagedObject, page: value };
        setPagedObject(obj);
        handlePagedForuns(obj);
    };

    function updateStatusForum(idForum) {
        setAwaitingData(true);
		RequestUtils.updateStatusForum(idForum).then((res) => {
			if (res?.svStatus && res.data) {
                let arr = arrForuns.value.filter((forum) =>  forum.idForum != idForum );
                arrForuns.setValue(arr);
				snackbar("Status do fórum atualizado com sucesso.").success();
			} else {
				snackbar(res.msg || "Não foi possível atualizar status do fórum.").error();
			}
			setAwaitingData(false);
		}).catch((e) => {
			snackbar("Erro ao atualizar status do fórum.").error();
			setAwaitingData(false);
		});
    }

    return (
        <Page className={classes.root} title="Fóruns">
            <Container maxWidth={false}>
                <Toolbar
                    inputValue={inputValue}
                    pagedObject={pagedObject}
                    onPressButton={onPressButton}
                    handleChange={handleChange}
                />
                {!awaitData ? (
                    <>
                        {arrForuns.value.length > 0 ? (
                            <>
                                <Box mt={3}>
                                    <Grid container spacing={3}>
                                        {arrForuns.value?.map((forum, idx) => (
                                            <Grid
                                                item
                                                key={idx}
                                                lg={4}
                                                md={6}
                                                xs={12}
                                            >
                                                <ForumCard
                                                    forum={forum}
                                                    updateStatusForum={updateStatusForum}
                                                />
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Box>
                                <Box mt={3} display="flex" justifyContent="center">
                                    <Pagination
                                        color="primary"
                                        size="small"
                                        count={pagedObject.amountPage}
                                        page={pagedObject.page}
                                        onChange={handleChangePage}
                                    />
                                </Box>
                            </>
                        ) : (
                            <Box mt={3} display="flex" justifyContent="center">
                                <Typography variant="body1" gutterBottom color="primary">
                                    Nenhum item encontrado.
                                </Typography>
                            </Box>
                        )}
                    </>
                ) : (
                    <Box mt={3} display="flex" justifyContent="center">
                        <CircularProgress />
                    </Box>
                )}
            </Container>
        </Page>
    )
}


export default ForunsList;